// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };

  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };

  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });
}
// accordions js end
(function() {
  faq_taggol();
})();


// =============== promo announcement bar copy code js
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".copy-code-right").forEach(function (copyBtn) {
    copyBtn.addEventListener("click", function () {
      let codeElement = this.closest(".coupan-right-block").querySelector(".copy-code-left");
      if (codeElement) {
        let codeText = codeElement.innerText.trim();
        navigator.clipboard.writeText(codeText).then(() => {
          let originalText = copyBtn.innerHTML;
          copyBtn.innerHTML = "&#10003;";

          setTimeout(() => {
            copyBtn.innerHTML = originalText;
          }, 2000);
        }).catch(err => {
          console.error("Copy failed", err);
        });
      }
    });
  });

  document.querySelectorAll(".discount-bar-close-icon").forEach(function (closeBtn) {
    closeBtn.addEventListener("click", function () {
      let bar = this.closest(".coupan-code");
      if (bar) {
        bar.style.display = "none";
      }
    });
  });

});

// autosize
function autosize() {
    const textareas = document.querySelectorAll('.autosize');

    textareas.forEach(textarea => {
        textarea.setAttribute('rows', 6);
        resize(textarea);

        textarea.addEventListener('input', () => resize(textarea));
    });

    function resize(textarea) {
        textarea.style.height = '122px';
        textarea.style.height = textarea.scrollHeight + 'px';
    }
}

autosize();

//cross cell product
function initRelatedProductsSwiper() {
  const swipers = document.querySelectorAll('.related-products-swiper');

  swipers.forEach((swiperEl) => {
    if (swiperEl.classList.contains('swiper-initialized')) return;

    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 600,
      loop: false,
      pagination: {
        el: swiperEl.querySelector('.swiper-pagination'),
        clickable: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 1
          ,
        },
        990: {
          slidesPerView: 1,
        },
      },
    });
  });
}

document.addEventListener('DOMContentLoaded', initRelatedProductsSwiper);
document.addEventListener('shopify:section:load', initRelatedProductsSwiper);

//product tab
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".tab-btn");
  const contents = document.querySelectorAll(".tab-content");

  buttons.forEach(btn => {
    btn.addEventListener("click", function () {
      const target = this.getAttribute("data-tab");

      buttons.forEach(b => b.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      this.classList.add("active");
      document.getElementById(target).classList.add("active");
    });
  });
});

//hover grandchild or child menu
document.addEventListener("DOMContentLoaded", function () {
  const megaMenus = document.querySelectorAll(".mega-menu");
  const productBlocks = document.querySelectorAll(".mega-dynamic-block");

  const menuLinks = document.querySelectorAll("[data-product]");
  menuLinks.forEach(link => {
    link.addEventListener("mouseenter", function () {
      const handle = this.getAttribute("data-product");

      productBlocks.forEach(block => {
        if (block.getAttribute("data-products") === handle) {
          block.style.display = "block";
        } else {
          block.style.display = "none";
        }
      });

      menuLinks.forEach(l => l.classList.remove("active"));
      this.classList.add("active");
    });
  });

  megaMenus.forEach(menu => {
    menu.addEventListener("mouseenter", function () {

      const firstLink = menu.querySelector("[data-product]");

      if (firstLink) {
        firstLink.dispatchEvent(new Event("mouseenter"));
      }

    });
  });
});

//bundle product
// =========================================================
// QUARTETT-BUNDLE (Opt-in)
// In assets/dynamic.js den vorhandenen Abschnitt
//     //bundle product
//     document.addEventListener("DOMContentLoaded", function () { ... });
// KOMPLETT durch diesen Block ersetzen.
//
// Unterschied zur alten Version:
//  - Das Quartett wird NICHT mehr automatisch vorausgewählt.
//  - Es landet nur im Warenkorb, wenn der Kunde den Button
//    "Quartett hinzufügen" (#BundleAddToggle) aktiv klickt.
// =========================================================

//bundle product
document.addEventListener("DOMContentLoaded", function () {
  const select = document.querySelector(".custom-select");
  if (!select) return;

  const wrapper = select.closest(".bundle-dropdown");
  const selected = select.querySelector(".select-selected");
  const options = select.querySelectorAll(".select-option");
  const hiddenInput = document.getElementById("BundleVariantId");
  const toggle = document.getElementById("BundleAddToggle");

  if (!selected || !options.length || !hiddenInput) return;

  // Chevron nur zeigen, wenn es mehr als ein Quartett zur Auswahl gibt
  if (wrapper && options.length > 1) wrapper.classList.add("has-multiple");

  // Aktuell gewähltes Quartett (für Anzeige) – aber NOCH NICHT in den Warenkorb
  let chosenVariant = "";
  let added = false;

  const first = select.querySelector(".select-option.is-default") || options[0];
  if (first) {
    selected.innerHTML = first.innerHTML;
    chosenVariant = first.dataset.variant;
  }

  function syncState() {
    // hiddenInput nur befüllen, wenn der Kunde aktiv hinzugefügt hat
    hiddenInput.value = added ? chosenVariant : "";
    if (toggle) {
      toggle.classList.toggle("is-added", added);
      toggle.setAttribute("aria-pressed", added ? "true" : "false");
    }
  }
  syncState();

  // Opt-in-Button: hinzufügen / entfernen
  if (toggle) {
    toggle.addEventListener("click", function () {
      added = !added;
      syncState();
    });
  }

  // Dropdown auf-/zuklappen (nur relevant bei mehreren Quartetten)
  selected.addEventListener("click", () => {
    if (options.length > 1) select.classList.toggle("open");
  });

  // Anderes Quartett wählen
  options.forEach(opt => {
    opt.addEventListener("click", function () {
      selected.innerHTML = this.innerHTML;
      chosenVariant = this.dataset.variant;
      select.classList.remove("open");
      syncState();
    });
  });

  // Beim Hinzufügen des Hauptprodukts ggf. das Quartett mitschicken
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form.matches('.product-form form')) return;
    if (!hiddenInput.value) return; // kein Opt-in -> nur das Buch wird hinzugefügt
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: hiddenInput.value, quantity: 1 })
    })
      .then(() => {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', { bubbles: true })
        );
      })
      .catch(err => console.error('Bundle Error:', err));
  });
});

//mobile drawer submenu
document.addEventListener("DOMContentLoaded", function() {
  const grandChildDetails = document.querySelectorAll(
    '.menu-drawer__submenu details'
  );
  grandChildDetails.forEach(detail => {
    detail.addEventListener("toggle", function() {
      if (this.open) {
        grandChildDetails.forEach(other => {
          if (other !== this && other.closest('.menu-drawer__submenu') === this.closest('.menu-drawer__submenu')) {
            other.removeAttribute("open");
          }
        });
      }
    });
  });
});

//search page empty
document.addEventListener("DOMContentLoaded", function () {
  const productGrid = document.querySelector('.product-grid');
  const productGridContainer = document.querySelector('#ProductGridContainer');

  if (productGrid && productGridContainer) {
    if (productGrid.children.length === 0) {
      productGridContainer.style.display = "none";
    }
  }
});

//collection search reset button
document.addEventListener("DOMContentLoaded", function () {
  const searchInputs = document.querySelectorAll(".search__input");
  searchInputs.forEach(function(input){
    const form = input.closest(".search");
    const resetBtn = form.querySelector(".reset__button");
    input.addEventListener("input", function(){
      if(input.value.length > 0){
        resetBtn.classList.remove("hidden");
      }else{
        resetBtn.classList.add("hidden");
      }
    });
    resetBtn.addEventListener("click", function(){
      setTimeout(function(){
        resetBtn.classList.add("hidden");
      },10);
    });

  });

});

//page tab section
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-menu");
  const contents = document.querySelectorAll(".tab-content-item");

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      const target = this.getAttribute("data-tab");

      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      this.classList.add("active");
      document.querySelector(`[data-content="${target}"]`).classList.add("active");
    });
  });
});

// not found search page
(function () {
  const container = document.querySelector('#custom-page-container');
  if (!container) return; // läuft nur noch auf der Suchseite ohne Treffer

  const escapeHtml = (s) =>
    String(s).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[c]);

  fetch('/pages/suche-berg-nicht-gefunden')
    .then((res) => res.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');

      // Suchbegriff in den Satz mit „…" einsetzen
      const selector = doc.querySelector('[data-search-selector]');
      if (selector) {
        const parts = selector.innerText.split('„');
        const first = parts[0] || '';
        const last = (parts[1] || '').split('“')[1] || '';
        const term = document.querySelector('#Search-In-Template')?.value || '';
        selector.innerHTML = `<strong>${first}„${escapeHtml(term)}“${last}</strong>`;
      }

      // NUR den Textblock übernehmen – das Formular steht jetzt direkt in main-search.liquid
      const source =
        doc.querySelector('.rich-text')?.closest('.shopify-section') ||
        doc.querySelector('#MainContent');
      if (source) container.innerHTML = source.innerHTML;
    })
    .catch(() => {});
})();

// language variant triggger
document.addEventListener("DOMContentLoaded", function () {
  const lang = document.documentElement.lang;
  let selectedLang = null;
  if (lang === 'en') {
    selectedLang = 'Englisch';
  } else if (lang === 'de') {
    selectedLang = 'Deutsch';
  }
  if (!selectedLang) return;

  const variantRadios = document.querySelectorAll('input[type="radio"]');
  variantRadios.forEach((radio) => {
    if (radio.value.trim() === selectedLang) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: false }));
    }
  });
});


// product image zoom
// =========================================================
// LUPE / BILDZOOM (lazy, Stand 2026-08-27)
//
// Vorher lief setupZoom() fuer jeden Slide direkt beim Seitenaufbau
// und lud dabei ueber `new Image()` das data-image-full jedes Slides
// sofort herunter - gemessen 1.4-2.2 MB pro Produktseite, auch auf
// Mobilgeraeten, wo die Lupe per CSS display:none ist.
//
// Jetzt laedt das grosse Bild erst beim ersten mouseenter auf dem
// jeweiligen Slide, und nur wenn die Lupe an diesem Viewport sichtbar
// ist (Breakpoint kommt aus dem Theme-CSS, kein eigener Pixelwert).
// Das Zoom-Verhalten selbst ist unveraendert.
// =========================================================
function initLoupe() {
  // Geraete ohne echten Hover (Touch) bekommen die Lupe gar nicht erst.
  if (!window.matchMedia('(hover: hover)').matches) return;

  document.querySelectorAll('.js-loupe').forEach((container) => {

    const image = container.querySelector('.js-loupe-image');
    const loupe = container.querySelector('.js-loupe-element');

    if (!image || !loupe) return;

    // initLoupe() laeuft auch bei variant:change erneut. Ohne diese
    // Sperre haengt jeder Durchlauf einen weiteren Listener an.
    if (container.dataset.loupeBound === '1') return;
    container.dataset.loupeBound = '1';

    loupe.style.backgroundImage = 'none';

    const setupZoom = () => {
      const bigImageUrl = image.dataset.imageFull;
      if (!bigImageUrl) return;

      loupe.style.backgroundImage = `url(${bigImageUrl})`;

      let zoom = 1.5;

      const bigImg = new Image();

      bigImg.onload = function () {

        const bigWidth = bigImg.width;
        const bigHeight = bigImg.height;

        loupe.style.backgroundSize = `${bigWidth * zoom}px ${bigHeight * zoom}px`;
        container.onmousemove = null;
        container.onmousemove = (e) => {

          const rect = image.getBoundingClientRect();

          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;

          const xPercent = x / rect.width;
          const yPercent = y / rect.height;

          const bgX = xPercent * bigWidth * zoom;
          const bgY = yPercent * bigHeight * zoom;

          loupe.style.left = `${x}px`;
          loupe.style.top = `${y}px`;

          loupe.style.backgroundPosition =
            `-${bgX - loupe.offsetWidth / 2}px -${bgY - loupe.offsetHeight / 2}px`;
        };
      };

      bigImg.src = bigImageUrl;
    };

    // Erst beim ersten Hover laden. Kein `once: true`: ist die Lupe beim
    // ersten Hover display:none (schmales Fenster), wird nichts geladen
    // und der naechste Hover versucht es erneut.
    const start = () => {
      if (container.dataset.loupeLoaded === '1') return;
      if (getComputedStyle(loupe).display === 'none') return;

      container.dataset.loupeLoaded = '1';

      if (image.complete) {
        setupZoom();
      } else {
        image.onload = setupZoom;
      }
    };

    container.addEventListener('mouseenter', start);

  });
}

document.addEventListener('DOMContentLoaded', initLoupe);
document.addEventListener('variant:change', () => {
  setTimeout(() => {
    initLoupe();
  }, 400);
});
document.addEventListener('change', (e) => {
  if (e.target.matches('select[name="id"], input[name="id"]')) {
    setTimeout(() => {
      initLoupe();
    }, 400);
  }
});

// Mega-Menü: Produktkarten erst beim Hover nachladen (2026-08-30)
document.addEventListener("DOMContentLoaded", function () {
  var pending = {};
  function loadMegaCard(handle) {
    var block = document.querySelector('.mega-dynamic-block[data-products="' + handle + '"]');
    if (!block) return;
    var slot = block.querySelector(".mega-product-card[data-card-url]");
    if (!slot || slot.childElementCount > 0) return;
    var url = slot.getAttribute("data-card-url");
    if (!url || pending[url]) return;
    pending[url] = true;
    var sep = url.indexOf("?") > -1 ? "&" : "?";
    fetch(url + sep + "sections=mega-card")
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json["mega-card"];
        if (!html) return;
        var tmp = document.createElement("div");
        tmp.innerHTML = html;
        var wrapper = tmp.firstElementChild;
        slot.innerHTML = wrapper ? wrapper.innerHTML : html;
      })
      .catch(function () { pending[url] = false; });
  }
  document.querySelectorAll("[data-product]").forEach(function (link) {
    link.addEventListener("mouseenter", function () {
      loadMegaCard(this.getAttribute("data-product"));
    });
  });
  document.querySelectorAll(".mega-menu").forEach(function (menu) {
    menu.addEventListener("mouseenter", function () {
      var first = menu.querySelector("[data-product]");
      if (first) loadMegaCard(first.getAttribute("data-product"));
    });
  });
});
// Produkt-Modal: Bilder erst beim Oeffnen laden (2026-08-30)
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("product-modal").forEach(function (modal) {
    function activateMedia() {
      if (modal.dataset.mediaActivated === "1") return;
      modal.dataset.mediaActivated = "1";
      modal.querySelectorAll("[data-src], [data-srcset]").forEach(function (el) {
        if (el.dataset.srcset) { el.setAttribute("srcset", el.dataset.srcset); el.removeAttribute("data-srcset"); }
        if (el.dataset.src) { el.setAttribute("src", el.dataset.src); el.removeAttribute("data-src"); }
      });
    }
    // Dawn setzt beim Oeffnen das open-Attribut auf <product-modal>
    new MutationObserver(function () {
      if (modal.hasAttribute("open")) activateMedia();
    }).observe(modal, { attributes: true, attributeFilter: ["open"] });
    // Fallback: Klick auf einen Oeffner dieses Modals
    document.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest('[data-modal="#' + modal.id + '"]')) activateMedia();
    });
  });
});